/*
  Legacy World — color automático del header de cristal
  Cada elemento del menú (logo, enlaces, LGCY, iconos y avisos) mira
  lo que tiene justo detrás y recibe data-lg-tone="light" o "dark":
    light → detrás hay algo claro  → se pinta en azul de marca
    dark  → detrás hay algo oscuro → se pinta en blanco
*/
(function () {
  var header;
  var canvas = document.createElement('canvas');
  canvas.width = canvas.height = 6;
  var ctx = canvas.getContext('2d', { willReadFrequently: true });
  var THRESHOLD = 0.6; /* 0 = negro, 1 = blanco. Por encima de esto se considera fondo claro */

  function lum(r, g, b) {
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }

  function parseColor(str) {
    var m = str && str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    return m ? { l: lum(+m[1], +m[2], +m[3]), a: m[4] !== undefined ? +m[4] : 1 } : null;
  }

  /* Copias de las fotos con permiso de lectura (CORS).
     Las imágenes de Shopify vienen de su CDN; el navegador no deja leer sus píxeles
     directamente, pero sí una copia cargada con crossOrigin="anonymous". */
  var proxies = {};
  function proxyFor(el) {
    var src = el.currentSrc || el.src;
    if (!src || el.tagName !== 'IMG') return null;
    var p = proxies[src];
    if (!p) {
      p = proxies[src] = new Image();
      p.crossOrigin = 'anonymous';
      p.onload = function () { p.ready = true; schedule(); };
      p.onerror = function () { p.failed = true; };
      p.src = src;
    }
    return p.ready ? p : null;
  }

  function sample(source, el, x, y) {
    var r = el.getBoundingClientRect();
    var w = el.videoWidth || el.naturalWidth;
    var h = el.videoHeight || el.naturalHeight;
    if (!w || !h || !r.width || !r.height) return null;
    var fit = getComputedStyle(el).objectFit;
    var scale = fit === 'contain' ? Math.min(r.width / w, r.height / h) : Math.max(r.width / w, r.height / h);
    var sx = (x - r.left - (r.width - w * scale) / 2) / scale;
    var sy = (y - r.top - (r.height - h * scale) / 2) / scale;
    var size = 24 / scale;
    var k = source === el ? 1 : (source.naturalWidth / w); /* la copia puede tener otro tamaño */
    ctx.clearRect(0, 0, 6, 6);
    ctx.drawImage(source, (sx - size / 2) * k, (sy - size / 2) * k, size * k, size * k, 0, 0, 6, 6);
    var d = ctx.getImageData(0, 0, 6, 6).data, t = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 10) continue;
      t += lum(d[i], d[i + 1], d[i + 2]);
      n++;
    }
    return n ? t / n : null;
  }

  /* Brillo de la zona de una foto/video que queda detrás del punto (x, y) */
  function mediaLum(el, x, y) {
    try {
      return sample(el, el, x, y);
    } catch (e) {
      /* Una imagen sin permiso "ensucia" el lienzo para siempre: creamos uno nuevo */
      canvas = document.createElement('canvas');
      canvas.width = canvas.height = 6;
      ctx = canvas.getContext('2d', { willReadFrequently: true });
      try {
        var p = proxyFor(el);
        return p ? sample(p, el, x, y) : null;
      } catch (e2) {
        return null;
      }
    }
  }

  /* Brillo final en un punto, sumando capas semitransparentes (overlays) sobre la foto */
  function lumAt(x, y) {
    var stack = document.elementsFromPoint(x, y);
    var layers = [];
    var base = 1;
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (header.contains(el) || el.contains(header)) continue;
      if (el.tagName === 'IMG' || el.tagName === 'VIDEO') {
        /* Sobre la foto o video de la portada (primera sección): siempre blanco */
        if (hero && header.hasAttribute('transparent') && hero.contains(el)) return 0;
        var m = mediaLum(el, x, y);
        base = m === null ? 0.35 : m; /* si no se puede leer la foto, se asume oscura */
        break;
      }
      var c = parseColor(getComputedStyle(el).backgroundColor);
      if (c && c.a > 0.02) {
        if (c.a >= 0.98) { base = c.l; break; }
        layers.push(c);
      }
    }
    if (i === stack.length) {
      /* Nada opaco debajo: usar el fondo de la página */
      var pc = parseColor(getComputedStyle(document.body).backgroundColor);
      base = pc && pc.a > 0 ? pc.l : 1;
    }
    for (var j = layers.length - 1; j >= 0; j--) {
      base = layers[j].a * layers[j].l + (1 - layers[j].a) * base;
    }
    return base;
  }

  function items() {
    var list = header.querySelectorAll(
      '.header-logo, .menu-list__link, .header__row button, .header__row a[href*="cart"], .header__row cart-icon, .header__row .header-actions__action, .lg-marquee'
    );
    return Array.prototype.filter.call(list, function (el) {
      if (el.closest('[hidden], dialog, .menu-list__submenu, .header-menu__submenu')) return false;
      if (el.parentElement && el.parentElement.closest('.header-logo, .menu-list__link, .lg-marquee, .header__row button')) return false;
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    });
  }

  var hero = null;
  function update() {
    hero = document.querySelector('main > .shopify-section:first-child');
    var els = items();
    var logo = null, sum = 0, n = 0;
    header.style.pointerEvents = 'none';
    els.forEach(function (el) {
      if (el.classList.contains('header-logo')) { logo = el; return; } /* el logo se decide al final */
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return; /* fuera de pantalla (animación): no medir */
      var y = Math.max(1, Math.min(r.top + r.height / 2, window.innerHeight - 2));
      /* Dos muestras por elemento (izquierda y derecha) para textos largos */
      var l = (lumAt(r.left + r.width * 0.3, y) + lumAt(r.left + r.width * 0.7, y)) / 2;
      if (!el.classList.contains('lg-marquee')) { sum += l; n++; }
      var tone = l > THRESHOLD ? 'light' : 'dark';
      if (el.getAttribute('data-lg-tone') !== tone) el.setAttribute('data-lg-tone', tone);
    });
    /* El logo sigue el tono general de la barra (así no cambia de color a medias) */
    if (logo) {
      var avg = n ? sum / n : 1;
      var lt = avg > THRESHOLD ? 'light' : 'dark';
      if (logo.getAttribute('data-lg-tone') !== lt) logo.setAttribute('data-lg-tone', lt);
    }
    header.style.pointerEvents = '';
  }

  var ticking = false;
  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { update(); ticking = false; });
  }

  function init() {
    header = document.getElementById('header-component');
    if (!header || !header.classList.contains('header--glass')) return;
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', update);
    document.addEventListener('load', function (e) {
      if (e.target && (e.target.tagName === 'IMG' || e.target.tagName === 'VIDEO')) schedule();
    }, true);
    /* Recalcular al terminar la animación de entrada y cada segundo
       (videos, sliders y cambios de sección que no generan scroll) */
    header.addEventListener('animationend', schedule);
    /* Solo se revisa de forma periódica si hay videos en la página */
    if (document.querySelector('video')) setInterval(schedule, 1200);
    /* Y cuando cambia el contenido (secciones que cargan después) */
    setTimeout(schedule, 600);
    setTimeout(schedule, 2000);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
